import { useEffect, useState } from 'react'

import {
  Box,
  SystemProps,
  Tooltip,
  useBreakpointValue,
  UseTooltipProps,
} from '@chakra-ui/react'
import { faInfoCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons'

import Icon from '../Icon/Icon'
export type TooltipProps = {
  children?: React.ReactNode | React.ReactNode[] | null
  label: string
  icon?: IconDefinition
  defaultIconColor?: string
} & UseTooltipProps &
  SystemProps

const CustomTooltip: React.FC<TooltipProps> = ({
  children,
  label,
  icon = faInfoCircle,
  defaultIconColor = 'stone',
  ...props
}) => {
  const isLarge = useBreakpointValue({ sm: false, lg: true })
  const [showing, setShowing] = useState<boolean>(false)

  const handleDismissEvents = () => {
    setShowing(false)
  }

  useEffect(() => {
    document.addEventListener('scroll', handleDismissEvents, true)
    document.addEventListener('pointerdown', handleDismissEvents)

    return () => {
      document.removeEventListener('scroll', handleDismissEvents, true)
      document.removeEventListener('pointerdown', handleDismissEvents)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (isLarge === undefined) return null

  return (
    <Tooltip
      mx={4}
      fontSize={12}
      borderRadius={6}
      p={isLarge ? 2 : 3}
      label={label}
      placement="top"
      hasArrow
      closeOnEsc
      isOpen={showing}
      {...props}
    >
      <Box
        m={0}
        p={0}
        display="inline"
        data-testid="tooltip"
        cursor="pointer"
        onPointerDown={(ev) => {
          ev.stopPropagation()
          ev.preventDefault()
          setShowing(!showing)
        }}
        onMouseEnter={() => setShowing(true)}
        onMouseLeave={() => setShowing(false)}
      >
        {children ? (
          children
        ) : (
          <Icon
            display="inline"
            m={0}
            w={'auto'}
            p={0}
            icon={icon}
            color={defaultIconColor}
            boxSize="20px"
          />
        )}
      </Box>
    </Tooltip>
  )
}

export default CustomTooltip
